import { Autocomplete, AutocompleteProps, ListSubheader, MenuItem, StandardTextFieldProps, SxProps, TextField, TextFieldProps } from "@mui/material"
import { TalentSpecializations } from "../../Types/General"
import { Fragment } from "react";

interface IProps extends Partial<AutocompleteProps<any, any, any, any, any>>{
    excludeList?: string[];
    placeholder?: string;
    textFieldProps?: TextFieldProps; 
} 

export const KaziSpecializations = ({excludeList = [], placeholder, textFieldProps, ...props}:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const options = TalentSpecializations.map( s => s.roles).flat().map( r => (
        {
            category: TalentSpecializations.find( s => s.roles.includes(r))!.label,
            title: r
        }
    )).sort( (a,b) => {if (a.category > b.category) return 1;if(a.category < b.category) return -1;return 0 })
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return ( 
        <Autocomplete
            {...props}
            value={options.find( opt => opt.title === props.value)}
            onChange={(event: any, newValue) =>{
                //@ts-ignore
                props.onChange(newValue ? newValue.title : null);
            }}
            options={options.filter( option => !excludeList.includes(option.title))}
            isOptionEqualToValue={ (option, value) => option.title === value}
            groupBy={option => option.category}
            getOptionLabel={option => option.title}
            renderInput={(params) =>                             
                <TextField
                    {...params}
                    {...textFieldProps}
                    placeholder={placeholder}
                />
            }
        />
    )
}